import React from "react";
import { TransactionDetailsGrid } from "cvmgmt-txn-history-ui-lib";
import { getEnv } from "../../../Constants/env";
import { useSelector } from "react-redux";
import { useIdToken } from "../../../hooks/useAuthSession";

interface AuditHistoryProps {
  workdayID?: string | null;
  gridTitle?: string;
}

const AuditHistory: React.FC<AuditHistoryProps> = ({
  workdayID = null,
  gridTitle = "History",
}) => {
  const idToken = useIdToken();
  const { env } = useSelector((state: any) => state?.createApplication);

  return (
    <>
      {idToken && (
        <TransactionDetailsGrid
          setTransactionInfo={(data: any) => {}}
          sortings={[
            {
              id: "activity_date",
              desc: true,
            },
          ]}
          gridtitle={gridTitle}
          url={`${getEnv()?.baseURL}/audit/data?env=${env}`}
          payload={{
            sortingFilter: {
              filter: [],
              sort: [],
              page: {
                limit: 25,
                offset: 1,
              },
            },
            ...(workdayID && { workdayId: workdayID }),
          }}
          headers={{
            Authorization: idToken,
            "Content-Type": "application/json",
            Accept: "application/json",
          }}
          tableStyles={{ height: "calc(100vh - 30.5rem)" }}
        />
      )}
    </>
  );
};

export default AuditHistory;
